import React from 'react';
import TextField from '@material-ui/core/TextField';

import t from '../common/localization';
import { Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, Button, FormControl,
Container, Checkbox, FormControlLabel, Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainToolbar from '../MainToolbar';
import { sessionActions } from '../store';
import EditAttributesView from '../attributes/EditAttributesView';
import deviceAttributes from '../attributes/deviceAttributes';
import userAttributes from '../attributes/userAttributes';
import serverAttributes from '../attributes/serverAttributes';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  details: {
    flexDirection: 'column',
  },
  root: {
            padding: '10px',
            margin: '10px',
            marginLeft: '60px',
            },
}));

const ServerPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  const item = useSelector(state => state.session.server);
  const setItem = (updatedItem) => dispatch(sessionActions.updateServer(updatedItem));

  const handleSave = async () => {
    const response = await fetch('/api/server', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item),
    });

    if (response.ok) {
      history.goBack();
    }
  };

  return (
    <>
      <MainToolbar />
        {item &&
          <>
         <div className={classes.root}>
          <Grid container spacing={3}>
           <Grid item xs={8}>
           <Paper elevation={3}>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">
                  {t('sharedPreferences')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <TextField
                  margin="normal"
                  InputProps={{ disableUnderline: true }}
                  value={item.announcement || ''}
                  onChange={event => setItem({...item, announcement: event.target.value})}
                  label={t('serverAnnouncement')}
                  variant="standard" />
              </AccordionDetails>
            </Accordion>
          </Paper>
           <Grid container spacing={3}>
           <Grid item xs={12}>
            <Paper elevation={3}>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">
                  {t('sharedPermissions')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <FormControlLabel
                  control={<Checkbox checked={item.registration} onChange={event => setItem({...item, registration: event.target.checked})} />}
                  label={t('serverRegistration')} />
                <FormControlLabel
                  control={<Checkbox checked={item.readonly} onChange={event => setItem({...item, readonly: event.target.checked})} />}
                  label={t('serverReadonly')} />
                <FormControlLabel
                  control={<Checkbox checked={item.deviceReadonly} onChange={event => setItem({...item, deviceReadonly: event.target.checked})} />}
                  label={t('userDeviceReadonly')} />
                <FormControlLabel
                  control={<Checkbox checked={item.limitCommands} onChange={event => setItem({...item, limitCommands: event.target.checked})} />}
                  label={t('userLimitCommands')} />
              </AccordionDetails>
            </Accordion>
            </Paper>
            </Grid>
           </Grid>
           </Grid>

            <Grid item xs={4}>
            <Paper elevation={3}>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">
                  {t('sharedAttributes')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <EditAttributesView
                  attributes={item.attributes}
                  setAttributes={attributes => setItem({...item, attributes})}
                  definitions={{...userAttributes, ...serverAttributes, ...deviceAttributes}}
                  />
              </AccordionDetails>
            </Accordion>
            </Paper>
            </Grid>
            </Grid>
            </div>
          </>
        }
        <FormControl fullWidth margin='normal'>
          <div className={classes.buttons}>
            <Button type='button' color='primary' variant='outlined' onClick={() => history.goBack()}>
              {t('sharedCancel')}
            </Button>
            <Button type='button' color='primary' variant='contained' onClick={handleSave}>
              {t('sharedSave')}
            </Button>
          </div>
        </FormControl>
    </>
  );
}

export default ServerPage;
